import * as React from "react"
import NavBar from "../components/NavBar";
import Footer from "../components/Footer";

const Layout = ({children, className, bg = 'bg-white'}: any) => {
    return (
        <main className={"flex flex-col overflow-auto " + (className ?? '') + ' ' + bg}>
            <NavBar bg={bg}/>
            <div className="mt-36 flex flex-col">
                {children}
            </div>
            <Footer/>
        </main>
    )
}

export default Layout
